export const ellipses = '...';
export const previous = '<';
export const next = '>';
